import React from 'react';
import { Grid } from '@material-ui/core';

import Title from 'components/typography/Title';
import BigRecipeCardLoading from 'components/recipes//cards/BigRecipeCardLoading';
import RecipesListLoading from 'components/recipes/list/RecipesListLoading';
import RecipesList from 'components/recipes/list/RecipesList';
import BigRecipeCard from 'components/recipes/cards/BigRecipeCard';

import FailedWarning from './FailedWarning';
import useMostRatedRecipes from './useMostRatedRecipes';

const MostRatedRecipes = () => {
  const {
    recipes,
    hasFailed,
    hasFinished,
    loadMoreRecipes,
    isLoading,
  } = useMostRatedRecipes();

  return (
    <Grid container direction="column">
      <Grid item container>
        <Title>Most rated recipes</Title>
      </Grid>

      {hasFailed && (
        <Grid item container style={{ marginTop: 32 }}>
          <FailedWarning
            onTryAgainButtonClick={loadMoreRecipes}
          ></FailedWarning>
        </Grid>
      )}

      {(isLoading || hasFinished) && (
        <Grid item container spacing={2} style={{ marginTop: 32 }}>
          <Grid item md={6} xs={12}>
            {isLoading || recipes.length < 1 ? (
              <BigRecipeCardLoading></BigRecipeCardLoading>
            ) : (
              <BigRecipeCard recipeModel={recipes[0]}></BigRecipeCard>
            )}
          </Grid>
          <Grid item md={6} xs={12}>
            {isLoading || recipes.length < 3 ? (
              <RecipesListLoading count={2}></RecipesListLoading>
            ) : (
              <RecipesList recipes={[recipes[1], recipes[2]]}></RecipesList>
            )}
          </Grid>
        </Grid>
      )}
    </Grid>
  );
};

export default MostRatedRecipes;
